.tiles {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(12.5rem, 1fr));
  gap: var(--tuna-spacing-1_5);
}

.tile {
  display: flex;
  align-items: flex-start;
  gap: var(--tuna-spacing-1_5);
  padding: var(--tuna-spacing-2);
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-radius-lg);
  background: var(--tuna-surface-elevated);
  color: var(--tuna-content-primary);
  font: inherit;
  text-align: start;
  cursor: pointer;
}

.tile:hover {
  background: var(--tuna-palette-action-hover);
}

.tile:focus-visible {
  outline: 2px solid var(--tuna-focus-ring);
  outline-offset: 2px;
}

.icon {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  width: var(--tuna-spacing-5);
  height: var(--tuna-spacing-5);
  border-radius: var(--tuna-shape-radius-md);
  background: var(--tuna-palette-action-hover);
  color: var(--tuna-palette-primary-main);
}

.text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.title {
  font-weight: var(--tuna-typography-fontWeight-bold);
}

.subtitle {
  font-size: var(--tuna-typography-fontSize-sm);
  color: var(--tuna-content-secondary);
}
